<template>
  <div>
    <!-- estrellas cuando se tiene valoracion -->
    <el-rate
      v-if="row.Valoracion > 0 && ![-1, 0].includes(row.Status)"
      v-model="row.Valoracion"
      disabled
      show-score
      text-color="#ff9900"
      :colors="colors"
    >
    </el-rate>
    <!-- estrellas para valorar -->

    <el-rate
      v-if="
        (row.Valoracion === 0 &&
          row.Status === 2 &&
          row.CreateById == currentUser.EmployeeId) ||
        (row.Valoracion === 0 &&
          row.Status === 3 &&
          row.CreateById == currentUser.EmployeeId)
      "
      v-model="rate"
      :texts="['Malo', 'Normal', 'Regular', 'Bueno', 'Excelente']"
      show-text
      :colors="colors"
      @change="handleRate(row)"
    >
    </el-rate>

    <el-dialog
      title="¿Para que valores mi servicio como excelente que debo mejorar?"
      width="30%"
      :visible.sync="dialogoComentarioValorationVisible"
      :before-close="handleCloseCommentario"
      :close-on-click-modal="false"
      :append-to-body="true"
    >
      <el-col :span="24">
        <el-form status-icon ref="ruleForm" class="demo-ruleForm">
          <el-form-item>
            <el-input v-model="comments" type="textarea"></el-input>
          </el-form-item>
        </el-form>
      </el-col>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancelDialog">Cancelar</el-button>
        <el-button type="primary" @click="addComent(row.Id, comments)"
          >Aceptar</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "GetRate",
  props: {
    row: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      rate: null,
      dialogoComentarioValorationVisible: false,
      valueToPoints: null,
      comments: "",
      iconClasses: ["icon-rate-face-1", "icon-rate-face-2", "icon-rate-face-3"], // same as { 2: 'icon-rate-face-1', 4: { value: 'icon-rate-face-2', excluded: true }, 5: 'icon-rate-face-3' }
      colors: ["#FF0000", "#f4d03e", "#008F39"]
    };
  },
  methods: {
    Selected(props) {
      props.Validate(props);
    },
    handleRate(requestRow) {
      if (
        this.rate == 5 &&
        requestRow.DiasRetrasadosSla > requestRow.SlaDaysToResponse
      ) {
        this.$message({
          type: "error",
          message:
            "Solicitudes con SLA vencidos no podrán ser calificadas con 5 estrellas"
        });
        this.rate = 0;
      } else {
        if (this.rate <= 4) {
          this.dialogoComentarioValorationVisible = true;
        } else {
          // Peticion para guardar el valor
          this.addComent(requestRow.Id, "Servicio Excelente");
        }
      }
    },
    validate() {
      const url = "/api/InternalServiceRequest/SetValidation";
      this.$http
        .get(url, {
          params: {
            internalRequestId: this.row.Id,
            userId: this.currentUser.EmployeeId
          }
        })
        .then((resp) => {
          if (resp.data) {
            this.$store.commit("SET_UPDATE_INTERNAL_REQUESTS", true);
            this.$emit("success");
            this.$message({
              type: "success",
              message: "Solicitud validada exitosamente"
            });
            this.rate = 0;
            this.dialogoComentarioValorationVisible = false;
          } else {
            this.$message.error("Error al establecer Estado de la solcitud");
          }
        })
        .catch((error) => {
          this.$message.error("Error al establecer Estado de la solcitud");
          console.error(error);
        });
    },
    addComent(InternalServiceRequest, comment = "") {
      if (comment.trim().length < 10) {
        this.$message({
          type: "error",
          message:
            "Favor colocar un mensaje de retroalimentación de al menos 10 caracteres"
        });
      } else {
        // Realizar peticion para guardar la data.
        var url = "/api/InternalServiceRequest/addComments";
        this.$http
          .get(url, {
            params: {
              comments: comment != "" ? comment : this.comments,
              internalRequestId: InternalServiceRequest,
              createBy: this.currentUser.EmployeeId,
              tipo: 2
            }
          })
          .then((resp) => {
            //console.log("commente1: ", resp.data)
            if (resp.data) {
              this.$store.commit("my_request/SET_VAL_COMMENT", {
                myRequestId: InternalServiceRequest,
                statusId: this.row.Status,
                comment: comment
              });
              // this.$message({
              //   type: "success",
              //   message: "comentario agregado exitosamente!"
              // });
              this.addAssessment(
                InternalServiceRequest,
                this.rate,
                this.row.Status
              );
            } else {
              this.$message.error("Error al agregar comentario");
            }
          })
          .catch((error) => {
            //console.log("commente1 catch: ", error)
            this.$message.error("Error al agregar comentario");
            console.error(error);
          })
          .finally(() => {
            this.comments = "";
            this.dialogoComentarioValorationVisible = false;
            this.rate = 0;
          });
      }
    },

    handleCloseCommentario(done) {
      this.comments = "";
      done();
    },
    addAssessment(requestId, rate) {
      this.$http
        .post("/api/InternalServiceRequest/SetAssessment", {
          InternalRequestId: requestId,
          Rate: rate
        })
        .then((resp) => {
          if (resp.data) {
            this.$store.commit("SET_UPDATE_INTERNAL_REQUESTS", true);
            this.$emit("success");
            this.$message({
              type: "success",
              message: "Puntuación insertada exitosamente"
            });
            //this.$store.commit("activityFlow/changeIsRateSubmitted", this.row);
          } else {
            this.$message.error("Error al insertar la puntuacion");
          }
        })
        .catch((error) => {
          this.$message.error("Error al insertar la puntuacion");
          console.error(error);
        })
        .finally(() => {});
      this.$store.commit("activityFlow/changeIsRateSubmitted", this.row);
    },
    handleCancelDialog() {
      this.dialogoComentarioValorationVisible = false;
      this.rate = 0;
    }
  }
};
</script>
